import {ReactNode, useRef, forwardRef, useImperativeHandle} from 'react';
import {useIntl} from 'react-intl';
import {Popper, PopperTrigger} from '@baidu/luffy-comp-popper';
import Button, {ButtonSize, ButtonType} from '@/components/Button';
import styles from './index.module.scss';


export interface IGuideBaseProps {
    visible: boolean;
    children?: ReactNode;
    target: HTMLElement;
    placement?:
        | 'top-start'
        | 'top'
        | 'top-end'
        | 'right-start'
        | 'right'
        | 'right-end'
        | 'bottom-end'
        | 'bottom'
        | 'bottom-start'
        | 'left-end'
        | 'left'
        | 'left-start';
    className?: string;
    onClose?: () => void;
    onPopperMouseEnter?: () => void;
    onPopperMouseLeave?: () => void;
    title?: string | ReactNode;
    content: string | ReactNode;
    visibleBtns?: boolean;
    width?: number;
}

export interface IGuideBaseRef {
    getPopperWrapEl(): (HTMLDivElement | null);
}

export default forwardRef<IGuideBaseRef, IGuideBaseProps>((props, ref) => {
    const intl = useIntl();
    const popperWrapRef = useRef<HTMLDivElement>(null);
    const {
        visible,
        target,
        title,
        content,
        className,
        onClose,
        onPopperMouseEnter,
        onPopperMouseLeave,
        visibleBtns = true,
        width,
        placement = 'bottom',
    } = props;

    useImperativeHandle(ref, () => {
        return {
            getPopperWrapEl() {
                return popperWrapRef.current;
            },
        };
    });

    return (
        <PopperTrigger visible={visible} target={target}>
            {props.children}
            <Popper
                className={styles.popperWrap}
                onMouseEnter={onPopperMouseEnter}
                onMouseLeave={onPopperMouseLeave}
                withArrow
                placement={placement}
                popperWrapRef={popperWrapRef}
            >
                <div
                    style={{width: typeof width === 'undefined' ? 'auto' : width}}
                    className={`${styles.root} ${className}`}
                >
                    {title && <h3 className={styles.title}>{title}</h3>}
                    <div className={styles.content}>{content}</div>
                    {visibleBtns && (
                        <div className={styles.footer}>
                            <Button
                                type={ButtonType.Important}
                                size={ButtonSize.SM}
                                onClick={onClose}
                                className={styles.button}
                            >
                                {intl.formatMessage({id: 'gotItTag'})}
                            </Button>
                        </div>
                    )}
                </div>
            </Popper>
        </PopperTrigger>
    );
});
